import { useTranslation } from "react-i18next";
import "../styles/hero_section/HeroSection.css";
import { useNavigate, useParams } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();
  return (
    <div className="hero_section">
      <div className="container">
        <div className="contain">
          <div className="heading_paragraph">
            <h1>{t("hero-title")}</h1>
            <p>{t("hero-description")}</p>
          </div>
          <div className="avatar_stack">
            <button
              className="upload"
              onClick={() => navigate(`/lang/${lang}/login`)}
            >
              {" "}
              {t("hero-upload-button")}
            </button>
            <div>
              <a href="#how-it-works" className=" explore">
                <span>{t("hero-explore-button")}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                >
                  <path d="M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="banner">
          <img
            src="/assets/Desktop_background.svg"
            alt="banner"
            className="desktop_banner"
          />
          <img
            src="/assets/Mobile_background.svg"
            alt="banner"
            className="mobile_banner"
          />
        </div>
      </div>
    </div>
  );
}
